import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';
// import {SingleDatePicker} from 'react-dates';
import 'moment/locale/th';
// import moment, { months } from 'moment';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { checkStatus } from '../../../../util/util';
import IconColorPicker from '../../UserControl/IconColorPicker/IconColorPicker';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import { Alert } from 'reactstrap';

class EditDevice extends Component {

    constructor(props) {

        super(props);
        
        this.state = {
            create_dtm: '',
            create_user: '',
            device_driver: '',
            device_group: '',
            device_id: 0,
            device_model: '',
            device_no: '',
            device_status: '',
            expire_date: moment(),
            imei: '',
            install_date: moment(),
            is_dlt_alert: '',
            last_upd_dtm: '',
            last_upd_user: '',
            model: '',
            petroleum_from_date: '',
            petroleum_km_rate: '',
            petroleum_liter_rate: '',
            petroleum_to_date: '',
            remarks: '',
            reseller_note: '',
            serial: '',
            sim_no: '',
            speed_limit: '',
            vendor: '',
            date: null,
            focused: null,
            driverList:[],
            symbol_color: this.props.deviceInfo.symbol_color,
            symbol_id: this.props.deviceInfo.symbol_id,
            driver_id:'',
            install_with_rfid: false,
            network_operator: "",
            last_paid_sim_no:moment(),
            expire_date_props: moment(),
            visible:false,
            type:'',
            icon_label:'',
            barVisible: false,
        }

        this.onDismiss = this.onDismiss.bind(this);
        this.handleChangeInstallDate = this.handleChangeInstallDate.bind(this);
        this.handleChangeExpireDate = this.handleChangeExpireDate.bind(this);
        this.handleChangeLastPaidSimNo = this.handleChangeLastPaidSimNo.bind(this);
    }

    

    componentWillMount(){

        
        
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.deviceInfo !== this.props.deviceInfo ) {
            let deviceInfo = nextProps.deviceInfo;

            let installDate = null;
            if(deviceInfo.install_date !== null && deviceInfo.install_date !== undefined && deviceInfo.install_date !== "")
                installDate = moment(this.changeformatDate( deviceInfo.install_date));

            let expireDate = null;
            if(deviceInfo.expire_date !== null && deviceInfo.expire_date !== undefined && deviceInfo.expire_date !== "")
                expireDate = moment(this.changeformatDate( deviceInfo.expire_date));

            let lastPaidSimDate = null;
            if(deviceInfo.last_paid_sim_no !== null && deviceInfo.last_paid_sim_no !== undefined && deviceInfo.last_paid_sim_no !== "")
                lastPaidSimDate = moment(this.changeformatDate( deviceInfo.last_paid_sim_no));

            let iconLabel = null;
            if(deviceInfo.icon_label !== null && deviceInfo.icon_label !== undefined && deviceInfo.icon_label !== "")
                iconLabel = deviceInfo.icon_label;
            else
                iconLabel = deviceInfo.device_no;

            this.setState({
                install_date :  installDate,
                expire_date:  expireDate,
                last_paid_sim_no: lastPaidSimDate,
                expire_date_props: expireDate,
                create_dtm :  deviceInfo.create_dtm,
                create_user :  deviceInfo.create_user,
                device_driver :  deviceInfo.device_driver,
                device_group :  deviceInfo.device_group,
                device_id :  deviceInfo.device_id,
                device_model :  deviceInfo.device_model,
                device_no :  deviceInfo.device_no,
                device_status :  deviceInfo.device_status,
                is_dlt_alert :  deviceInfo.is_dlt_alert,
                last_upd_dtm :  deviceInfo.last_upd_dtm,
                last_upd_user :  deviceInfo.last_upd_user,
                petroleum_from_date :  deviceInfo.petroleum_from_date,
                petroleum_km_rate :  deviceInfo.petroleum_km_rate,
                petroleum_liter_rate :  deviceInfo.petroleum_liter_rate,
                petroleum_to_date :  deviceInfo.petroleum_to_date,
                remarks :  deviceInfo.remarks,
                reseller_note :  deviceInfo.reseller_note,
                serial :  deviceInfo.serial,
                symbol_color :  deviceInfo.symbol_color?deviceInfo.symbol_color:"",
                symbol_id :  deviceInfo.symbol_id?deviceInfo.symbol_id:"",
                vendor :  deviceInfo.vendor,
                speed_limit: deviceInfo.speed_limit,
                install_with_rfid: deviceInfo.install_with_rfid,
                imei: deviceInfo.imei,
                sim_no: deviceInfo.sim_no,
                model:deviceInfo.model,
                network_operator: deviceInfo.network_operator,
                visible: deviceInfo.visible,
                type: deviceInfo.type,
                icon_label: iconLabel
            });
        }
    }

    componentDidMount(){
        
        this.getDriverList();
    }

    componentWillUnmount(){
        this.setState({
            driverList:[],

        });
    }

    getDriverList(){

        const { user_id, user_name,token} = this.props;
        fetch(`http://203.150.199.244/api/admin/getDriverList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":name
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    driverList:data.RESULT_DATA, 
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    dateWrapper(rDate){
        let rDateWrapper=rDate;
        if(rDate!=null && rDate.toObject().years>2500){
          rDateWrapper=moment((rDate.toObject().years-543)+'/'+rDate.toObject().months+'/'+rDate.toObject().date);
        }
        return rDateWrapper;
      }
      
      handleChangeInstallDate(date) {
          
        if(date == null){
            this.setState({
                install_date:null
            });
        }else{
            this.setState({
                install_date:date
            });
        }
        
        
      }

      handleChangeExpireDate(date) {

        if(date == null){
            this.setState({
                expire_date: null,
            });
        }else{
            this.setState({
                expire_date: date,
            });
        }
        
      }

      handleChangeLastPaidSimNo(date){
        this.setState({
            last_paid_sim_no: date
        });
      }

      handleChangeCheckbox = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          is_dlt_alert: value
        });
      }

      handleChangeInstallWithRfid = (event) => {
          
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            install_with_rfid: value
        });
      }

      handleChangeValiable = (event) => {
          
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            visible: !value
        });
      }

      convertMomentToString(moment){
        let date = moment.toObject().date;
        let months = moment.toObject().months;
        let years = moment.toObject().years;

        months = months+1;
        if(date.toString().length == 1){
            date = '0'+date;
        }
        if(months.toString().length == 1){
            months = '0'+months;
        }
        return date+'-'+months+'-'+years;

      }

    changeDriver(value){
        
        this.setState({device_driver: value});
    }

    TxtIconLabelChange = (label) => {
        this.setState({
            icon_label:label
        })
    }


      onClickSubmit(){
        const { onSubmit } = this.props;
        
        // const { isErrorField } = this.state;
        let data = {};
        let isErrorField = false;
        const {

            create_dtm,
            create_user,
            device_driver,
            device_group,
            device_id,
            device_model,
            device_no,
            device_status,
            expire_date,
            install_date,
            is_dlt_alert,
            last_upd_dtm,
            last_upd_user,
            petroleum_from_date,
            petroleum_km_rate,
            petroleum_liter_rate,
            petroleum_to_date,
            remarks,
            reseller_note,
            speed_limit,
            symbol_color,
            symbol_id,
            vendor,
            driver_id,
            install_with_rfid,
            imei,
            sim_no,
            model,
            network_operator,
            last_paid_sim_no,
            visible,
            type,
            icon_label
        } = this.state;

        
        // if (device_group && device_group.length >= 0) {
            
        if(device_group){
            data.device_group = device_group.trim();
        }else{
            data.device_group = "";
        }
        //     isErrorField = false;
        // } else {
        //     isErrorField = true;
        // }

        if (device_no && device_no.length > 0) {
            data.device_no = device_no.trim()
            isErrorField = false;
        } else {
            isErrorField = true;
        }

        if (device_model && device_model.length > 0) {
            data.device_model = device_model.trim()
        //     isErrorField = false;
        // } else {
        //     isErrorField = true;
        }

        if (device_driver && device_driver.length > 0) {
            data.device_driver = device_driver.trim()
        }

        // if (speed_limit > 0) {
            data.speed_limit = speed_limit;
        //     isErrorField = false;
        // } else {
        //     isErrorField = true;
        // }

        if (petroleum_km_rate >= 0) {
            data.petroleum_km_rate = petroleum_km_rate;
        //     isErrorField = false;
        // } else {
        //     isErrorField = true;
        }

        if (petroleum_liter_rate >= 0) {
            data.petroleum_liter_rate = petroleum_liter_rate;
        }

        if (reseller_note && reseller_note.length > 0) {
            data.reseller_note = reseller_note.trim();
        }

        if (remarks && remarks.length > 0) {
            data.remarks = remarks.trim();
        }

        console.log('install_date',install_date)
        if (install_date) {
            let install = this.convertMomentToString(install_date);
            data.install_date = install;
        }else{
            data.install_date = install_date;
        }

        console.log('expire_date',expire_date)
        if (expire_date) {
            let expire = this.convertMomentToString(expire_date);
            data.expire_date = expire;
        }else{
            data.expire_date = expire_date;
        }
        
        if (last_paid_sim_no) {
            let last_paid = this.convertMomentToString(last_paid_sim_no);
            data.last_paid_sim_no = last_paid;
        }
        data.device_id = device_id;
        data.is_dlt_alert = is_dlt_alert;
        data.symbol_color = symbol_color;
        data.symbol_id = symbol_id;
        data.driver_id = driver_id;

        data.install_with_rfid = install_with_rfid;
        data.imei = imei;
        data.sim_no = sim_no;
        data.model = model;
        data.network_operator = network_operator;
        data.visible = visible;
        data.type = type;
        data.icon_label = icon_label;
        // if (!isErrorField) {
            // onSubmit(data);
        // }
        AlertConfirm("แก้ไขข้อมูลอุปกรณ์"," ").then(isOk=>{
            if(isOk){
                
                const {
                    user_name,
                    user_id,
                    sideBarName,
                    deviceInfo,
                    token
                } = this.props;
                // const { dataCreateNewUser, deviceSelect ,manageDevice,petroleum_from_date,petroleum_to_date} = this.state;
                
                // if (sideBarName === 'deviceInformation') {
                    fetch(`http://203.150.199.244/api/admin/updateDevice/${deviceInfo.device_id}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token,
                        },
                        body: JSON.stringify({
                            "device_id":data.device_id,
                            "driver_id":data.driver_id,
                            "device_group": data.device_group, // "จัดกลุ่ม"
                            "device_no": data.device_no, // "ทะเบียนรถ"
                            "device_model": data.device_model, // "รุ่นรถ"
                            "device_driver": data.device_driver, // "คนขับรถ"
                            "speed_limit": data.speed_limit, // "จำกัดความเร็ว กม./ชม."
                            "petroleum_km_rate": data.petroleum_km_rate, // "อัตราการใช้น้ำมัน กม./ลิตร"
                            "petroleum_liter_rate": data.petroleum_liter_rate, // "อัตราการใช้น้ำมัน ลิตร/ชม."
                            "remarks": data.remarks, // "หมายเหตุ"
                            "is_dlt_alert": data.is_dlt_alert, // "แจ้งเตือนกรมขนส่ง"
                            "install_date": data.install_date, // "วันที่ติดตั้ง"
                            "expire_date": data.expire_date, // "วันครบกำหนด"
                            "reseller_note": data.reseller_note, // "Reseller Note"
                            "symbol_id": data.symbol_id, // "ตั้งค่า Marker สัญลักษณ์"
                            "symbol_color": data.symbol_color, // "ตั้งค่า Marker สี"
                            "petroleum_from_date": petroleum_from_date, // "ตั้งค่าน้ำมัน เริ่มจากวันที่"
                            "petroleum_to_date": petroleum_to_date, // "ตั้งค่าน้ำมัน ถึงวันที่"
                            "install_with_rfid": data.install_with_rfid,
                            "imei":  data.imei,
                            "sim_no":  data.sim_no,
                            "model":  data.model,
                            "network_operator":  data.network_operator,

                            "last_paid_sim_no": data.last_paid_sim_no,
                            "visible": data.visible,
                            "type": data.type,
                            "icon_label": data.icon_label
                        })
                    })
                        .then(response => { return checkStatus(response)})
                        .then((data) => {

                        if(data.RESULT_STATUS === "000") {
                            AlertCommit(true, "บันทึกข้อมูลเรียบร้อยแล้ว");
                            this.setState({barVisible: true});
                        }
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }


                            this.setState({
                                showModalConfirmManageDevice: false,
                                // isShowCreateNewDealer: false,
                                // notification: true,
        
                            })
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                      

            }
            
        });
    }
    setMarker(icon,color){
        this.setState({ symbol_id:icon, symbol_color:color});
        console.log("toto setMarker",icon,color);
    }

    changeformatDate(date){
        console.log('changeformatDate',date)
        let str = date.split("-");
        return str[2]+'-'+str[1]+'-'+str[0];
    }

    onChangeDriver(e){
        let val = e.target.value;
        let str = val.split(",");
        let id = str[0];
        let name = str[1];

        this.setState({
            device_driver:name,
            driver_id:id,
        });
    }

    // onChangeType(e){
    //     let val = e.target.value;
        
    //     if(val === 'Meitrack'){
    //         this.setState({
    //             type:val, 
    //             modelList:[
    //                 {label:"T1.1",value:"T1.1"},
    //                 {label:"T333",value:"T333"},
    //                 {label:"T330G-T",value:"T330G-T"},
    //             ],
    //         });
    //     } 
    //     else if(val === 'GPSiam'){
    //         this.setState({
    //             type:val,
    //             modelList:[
    //                 {label:"ID5(3G)",value:"ID5(3G)"},
    //             ],
    //         });
    //     }
    //     else if(val === 'iStartex'){
    //         this.setState({
    //             type:val,
    //             modelList:[
    //                 {label:"VT900T",value:"VT900T"},
    //             ],
    //         });
    //     }
    //     else if(val === 'Telnolika'){
    //         this.setState({
    //             type:val,
    //             modelList:[
    //                 {label:"FM1100",value:"FM1100"},
    //             ],
    //         });
    //     }
    //     else{
    //         this.setState({
    //             type:val,
    //             modelList:[],
    //         });
    //     }
        

        
    // }

    onDismiss() {
        this.setState({ barVisible: false });
    }

    render(){

        const {  deviceInfo,onSubmit} = this.props;
        
        const { driverList,symbol_id,symbol_color } = this.state;
        let modelList = [
            {label:"T333",value:"T333"},
            {label:"ID5(3G)",value:"ID5"},
            {label:"VT900",value:"VT900"},
            {label:"MVT340",value:"MVT340"},
            {label:"MVT380",value:"MVT380"},
            {label:"T1",value:"T1"},
            {label:"T333G",value:"T333G"},
            {label:"FM1100",value:"FM1100"},
        ];
        let typeList = [
            {label:"Meitrack",value:"Meitrack"},
            {label:"GPSiam",value:"GPSiam"},
            {label:"iStartex",value:"iStartex"},
            {label:"Telnolika",value:"Telnolika"},
        ];
        let bandList = ["AIS","DTAC","TRUE"];


        return(


        <div className="container-fluid">
            <div>
                <Alert color="success" isOpen={this.state.barVisible} toggle={this.onDismiss}>
                    บันทึกข้อมูลแล้ว {moment().format('HH:mm')}
                </Alert>
            </div>
            <div className="card">
                <div className="card-header">
                    <h5>แก้ไขข้อมูลอุปกรณ์</h5>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-md-7">
                            <form>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">เลขที่กล่อง</label>
                                    
                                    <div className="col-md-8" >
                                    <label className="col-form-label"><strong>{this.state.device_id}</strong></label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">จัดกลุ่ม</label>
                                    <div className="col-md-8" >
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.device_group}
                                            onChange={(e) => this.setState({ device_group: e.target.value })}
                                            onKeyUp={(e) => this.setState({ device_group: e.target.value })}
                                            // onKeyPress={(e) => this.setState({ device_group: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label ">ทะเบียนรถ</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.device_no}
                                            onChange={(e) => this.setState({ device_no: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">รุ่นรถ</label>
                                    <div className="col-md-8">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.device_model}
                                            onChange={(e) => this.setState({ device_model: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group  row">
                                    <label className="col-md-4  col-form-label ">คนขับรถ</label>
                                    <div className="form-group  col-md-8">
                                        {/* <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={device_driver}
                                            onChange={(e) => this.setState({ device_driver: e.target.value })}
                                        /> */}
                                        <select className="form-control" defaultValue={this.state.device_driver} onChange={(e) => this.onChangeDriver(e)} >
                                            <option value="">กรุณาเลือก</option>
                                            {
                                            driverList.map((item,key) => {
                                                return(
                                                    // (item.first_name === device_driver) && 
                                                    <option key={key} selected={this.state.device_driver == item.first_name} value={item.driver_id+','+item.first_name}>{item.first_name}</option> 
                                                )
                                            })
                                            }
                                     </select>
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">จำกัดความเร็ว</label>
                                    <div className="col-md-4">
                                        
                                        <div className="input-group mb-3">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            value={this.state.speed_limit}
                                            onChange={(e) => this.setState({ speed_limit: e.target.value })}
                                        />
                                        <div className="input-group-append ">
                                            <span className="input-group-text" id="basic-addon2">กม./ชม.</span>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group  row">
                                    <label className="col-md-4  col-form-label ">อัตราการใช้น้ำมัน</label>
                                    <div className="col-md-4">
                                        <div className="input-group mb-3">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.petroleum_km_rate}
                                            onChange={(e) => this.setState({ petroleum_km_rate: e.target.value })}
                                        />
                                        <div className="input-group-append ">
                                            <span className="input-group-text" id="basic-addon2">กม./ลิตร</span>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        
                                        <div className="input-group mb-3">
                                        <input  
                                            className="form-control"
                                            type="text"
                                            id="userName"
                                            defaultValue={this.state.petroleum_liter_rate}
                                            onChange={(e) => this.setState({ petroleum_liter_rate: e.target.value })}
                                        />
                                        <div className="input-group-append ">
                                            <span className="input-group-text" id="basic-addon2">ลิตร/ชม.</span>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group   row">
                                    <label className="col-md-4  col-form-label ">หมายเหตุ</label>
                                    <div className="col-md-8">
                                        <textarea  
                                            className="form-control"
                                            
                                            id="userName"
                                            value={this.state.remarks}
                                            onChange={(e) => this.setState({ remarks: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-4  col-form-label "></label>
                                    <div className="col-md-8">
                                        <label style={{paddingLeft:'2px'}}>
                                            <label className=" col-form-label " style={{cursor:"pointer"}}>
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.is_dlt_alert}
                                                    onChange={this.handleChangeCheckbox} />
                                                     แจ้งเตือนกรมขนส่ง
                                                    <br />
                                                    1. แจ้งเตือนความเร็ว เมื่อความเร็วเกิน <span style={{color:'red'}}>{this.state.speed_limit} km/h</span>
                                                    <br />    
                                                    2. แจ้งเตือนขับรถนานเกิน 4 ชั่วโมง
                                                    <br />
                                                    3. ไม่มีข้อมูลบัตรรูด หลังจาก start รถ 10 นาที
                                            </label>
                                            
                                        </label>
                                    </div>
                                </div>
                                {  (this.props.userLevel === 0 || this.props.userLevel === 1) && 
                                        <div>
                                        <hr/>
                                        <div className="form-group   row">
                                            <label className="col-md-4  col-form-label ">อีมี่</label>
                                            <div className="col-md-8">
                                                <input  
                                                    className="form-control"
                                                    type="text"
                                                    id="userName"
                                                    value={this.state.imei}
                                                    onChange={(e) => this.setState({ imei: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-4 col-form-label">ชนิด</label>
                                            <div className="col-md-8">
                                                <select
                                                    name="port"
                                                    className="form-control"
                                                    onChange={(e) => this.setState({type:e.target.value})}
                                                    defaultValue={this.state.model}>
                                                        <option selected value="">กรุณาเลือก</option>
                                                        {
                                                            
                                                            typeList.map((item,key) => {
                                                            return(
                                                                <option key={key} selected={this.state.type == item.value} value={item.value}>{item.label}</option> 
                                                            )
                                                        })
                                                        }
                                                </select>
    
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-4 col-form-label">แบบ</label>
                                            <div className="col-md-8">
                                                <select
                                                    name="port"
                                                    className="form-control"
                                                    onChange={(e) => this.setState({model:e.target.value})}
                                                    defaultValue={this.state.model}>
                                                        <option selected value="">กรุณาเลือก</option>
                                                        {
                                                            
                                                            modelList.map((item,key) => {
                                                            return(
                                                                <option key={key} selected={this.state.model == item.value} value={item.value}>{item.label}</option> 
                                                            )
                                                        })
                                                        }
                                                </select>
    
                                            </div>
                                        </div>
                                        <div className="form-group   row">
                                            <label className="col-md-4  col-form-label ">ซิม</label>
                                            <div className="col-md-8">
                                                <input  
                                                    className="form-control"
                                                    type="text"
                                                    id="userName"
                                                    value={this.state.sim_no}
                                                    onChange={(e) => this.setState({ sim_no: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-4 col-form-label">เครือข่าย</label>
                                            <div className="col-md-8">
                                                <select
                                                    name="port"
                                                    className="form-control"
                                                    onChange={(e) => this.setState({network_operator:e.target.value})}
                                                    defaultValue={this.state.network_operator}>
                                                        <option selected value="">กรุณาเลือก</option>
                                                        {
                                                            
                                                            bandList.map((item,key) => {
                                                            return(
                                                                <option key={key} selected={this.state.network_operator == item} value={item}>{item}</option> 
                                                            )
                                                        })
                                                        }
                                                </select>
    
                                            </div>
                                        </div>
                                        <div className="form-group   row">
                                            <label className="col-md-4  col-form-label ">วันที่เติมเงินค่า sim ครั้งล่าสุด</label>
                                            <div className="col-md-8">
                                                <DatePicker className="form-control"
                        
                                                    selected={this.state.last_paid_sim_no}
                                                    onChange={this.handleChangeLastPaidSimNo}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-4  col-form-label "></label>
                                            <div className="col-md-8">
                                                <label style={{paddingLeft:'2px'}}>
                                                    <label className=" col-form-label " style={{cursor:"pointer"}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.install_with_rfid}
                                                            onChange={this.handleChangeInstallWithRfid} />
                                                             ติดตั้งพร้อมเครื่องรูดบัตร
                                                    </label>
                                                </label>
                                            </div>
                                        </div>

                                        {
                                            this.state.expire_date_props === null &&

                                            <div className="form-group row">
                                                <label className="col-md-4  col-form-label "></label>
                                                <div className="col-md-8">
                                                    <label style={{paddingLeft:'2px'}}>
                                                        <label className=" col-form-label " style={{cursor:"pointer"}}>
                                                            <input
                                                                type="checkbox"
                                                                // checked={this.state.visible}
                                                                onChange={this.handleChangeValiable} />
                                                                ระงับการใช้งานชั่วคราว
                                                        </label>
                                                    </label>
                                                </div>
                                        </div>
                                        }
                                        
                                </div>
                                    
                                }
                                

                                { 
                                    this.props.userLevel !== 3 && this.props.userLevel !== 4 && 
                                    <div>
                                        <hr/>
                                        <div className="form-group   row">
                                            <label className="col-md-4  col-form-label ">วันที่ติดตั้ง</label>
                                            <div className="col-md-8">
                                                <DatePicker className="form-control"
                        
                                                    selected={this.state.install_date}
                                                    onChange={this.handleChangeInstallDate}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group   row">
                                            <label className="col-md-4  col-form-label ">วันครบกำหนด</label>
                                            <div className="col-md-8">
                                                
                                            {  this.props.userLevel === 2  && 
                                                <DatePicker className="form-control"
                                                readOnly
                                                selected={this.state.expire_date}
                                                onChange={this.handleChangeExpireDate}
                                                />
                                            }
                                            { this.props.userLevel === 3  &&  
                                                <DatePicker className="form-control"
                                                readOnly
                                                selected={this.state.expire_date}
                                                onChange={this.handleChangeExpireDate}
                                                />
                                            }
                                            {this.props.userLevel === 4  && 
                                                <DatePicker className="form-control"
                                                readOnly
                                                selected={this.state.expire_date}
                                                onChange={this.handleChangeExpireDate}
                                                />
                                            }
                                            {  this.props.userLevel === 0  && 
                                                <DatePicker className="form-control"
                                                
                                                selected={this.state.expire_date}
                                                onChange={this.handleChangeExpireDate}
                                                />
                                            }
                                            {
                                                this.props.userLevel === 1  && (this.state.expire_date_props === null) &&
                                                <DatePicker className="form-control"
                                                
                                                selected={this.state.expire_date}
                                                onChange={this.handleChangeExpireDate}
                                                />
                                            }
                                            {
                                                this.props.userLevel === 1  && (this.state.expire_date_props !== null) &&
                                                <DatePicker className="form-control"
                                                readOnly
                                                selected={this.state.expire_date}
                                                onChange={this.handleChangeExpireDate}
                                                />
                                            }
                                            </div>

                                        </div>
                                    </div>
                                }
                                
                                <div className="form-group   row">
                                    <label className="col-md-4 col-form-label ">Reseller Note</label>
                                    <div className="col-md-8">
                                        <textarea  
                                            className="form-control"
                                            
                                            id="userName"
                                            value={this.state.reseller_note}
                                            onChange={(e) => this.setState({ reseller_note: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-5">
                            <div className="card" style={{height:'100%'}}>
                                <div className="card-header">
                                    <strong>ตั้งค่า Marker</strong>
                                </div>
                                <div className="card-body">
                                {
                                    
                                    this.state.symbol_id != undefined ?
                                    <IconColorPicker openAlway={true} onIconColorSelected={this.setMarker.bind(this)} defaultIcon={this.state.symbol_id} defaultColor={this.state.symbol_color} icon_label={this.state.icon_label} onTxtIconLabelChange={this.TxtIconLabelChange}/>
                                    :null
                                }
                                    {/* <IconColorPicker openAlway={true} onIconColorSelected={this.setMarker.bind(this)} selectedIcon={symbol_id} selectedColor={symbol_color} /> */}
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <hr/>
                        <div className="text-right">
                            <input type="button" className="btn btn-primary" style={{marginTop:5,width:115}} onClick={() => {this.onClickSubmit()}} value="บันทึกข้อมูล" />
                          
                            <input type="button" className="btn btn-danger" style={{marginTop:5,marginLeft:5}}  value="ลบข้อมูล Log" />
                        </div>
                </div>
             </div>    
        </div>
            
        );
    }
}
EditDevice.defaultProps = {
    deviceInfo:{}
}

EditDevice.propTypes = {
    deviceInfo: PropTypes.object,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onSubmit:PropTypes.func.isRequired,
    userLevel:PropTypes.number.isRequired,
    onTxtIconLabelChange: PropTypes.func,
}
export default EditDevice;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/EditDevice.js